"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
function UrbanStoriesGrid() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="flex flex-col gap-6">
            <div className="aspect-[4/5] w-full bg-muted/50 animate-pulse" />
            <div className="h-5 w-24 bg-muted/50 animate-pulse" />
            <div className="h-8 w-3/4 bg-muted/50 animate-pulse" />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="py-12 text-center text-muted-foreground">
        <p>Failed to load resources. Please try again later.</p>
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="py-12 text-center text-muted-foreground">
        <p>No resources available at the moment.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-3">
      {posts.map((post, i) => {
      const dateStr = post.date ? new Date(post.date).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      }) : 'Recent';
      return <Card key={post.id} data-index={i} className="group flex flex-col gap-6 rounded-md border-none bg-transparent p-0 shadow-md">
            <Link to={post.link || "#"} className="block w-full overflow-hidden [perspective:1000px]">
              <div className="relative aspect-[4/5] w-full overflow-hidden bg-muted">
                <img src={post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679939/img/faith_resource_cover.png"} alt={post.title} className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:[transform:rotateX(4deg)_rotateY(-4deg)_scale(1.05)]" />
              </div>
            </Link>
            
            <CardHeader className="p-0">
              <div className="mb-3 flex items-center">
                <Badge variant="secondary" className="rounded-md px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-secondary-foreground bg-accent">
                  {dateStr}
                </Badge>
              </div>
              <CardTitle className="font-default text-2xl font-bold leading-tight tracking-tight text-foreground">
                <Link to={post.link || "#"} className="hover:underline decoration-1 underline-offset-4">
                  {post.title}
                </Link>
              </CardTitle>
            </CardHeader>
            
            <CardContent className="mt-auto p-0">
              <Link to={post.link || "#"} className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-widest text-primary transition-colors hover:text-accent">
                Read Article
                <ArrowRight className="size-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </CardContent>
          </Card>;
    })}
    </div>;
}
export default function UrbanStories() {
  const wp_query_params = {
    post_type: "post",
    per_page: 3,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="238807" id="the-study-desk" className="bg-background py-24 text-foreground lg:py-32">
      <div className="container mx-auto px-6 md:px-12">
        <div className="mb-16 flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <h2 className="font-default text-4xl font-bold tracking-tighter md:text-5xl lg:text-6xl text-primary">
              The Study Desk
            </h2>
            <p className="mt-4 font-sans text-lg text-muted-foreground">
              Deep dives into scripture, practical devotionals, and resources to help you grow in your walk with Christ.
            </p>
          </div>
          <Link to="/ResourcesPage" className="inline-flex items-center gap-2 border-b-2 border-accent pb-1 text-sm font-bold uppercase tracking-widest transition-colors hover:border-primary hover:text-primary text-accent">
            Explore All Resources
            <ArrowRight className="size-4" />
          </Link>
        </div>

        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 3,
        order: "desc",
        orderby: "date"
      }}>
          <UrbanStoriesGrid />
        </PostsProvider>
      </div>
    </section>;
}